<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <PCard
      :style="{
        width: '600px',
      }"
      class="relative-position"
    >
      <q-card-section>
        <span class="text-lg text-neutral text-weight-medium">
          Cancel Purchase Bill
        </span>
      </q-card-section>

      <q-card-section class="rounded-borders text-neutral-90 text-center">
        <q-form @submit="onSubmit">
          <PInput
            v-model="formData.reason"
            :validations="{
              label: 'Cancellation reason',
              required: true,
            }"
            placeholder="Enter reason to cancel"
            type="textarea"
            autogrow
          />
          <div class="flex q-pb-md">
            <q-checkbox
              v-model="removeFiles"
              label="Remove files associated with this Purchase Bill ?"
              class="text-neutral"
            />
          </div>
          <div class="flex justify-end">
            <PBtn
              :fluid="false"
              :loading="isLoading"
              label="Submit"
              type="submit"
            />
          </div>
        </q-form>
      </q-card-section>

      <PBtn
        class="absolute-top-right q-ma-xs"
        flat
        dense
        round
        @click="() => onDialogCancel()"
      >
        <CloseIcon class="icon--sm" />
      </PBtn>
    </PCard>
  </q-dialog>
</template>

<script setup>
import { extend, useDialogPluginComponent, useQuasar } from "quasar";
import CloseIcon from "assets/icons/close.svg";
import PConfirmDialog from "src/components/PConfirmDialog.vue";

const $q = useQuasar();

defineEmits([...useDialogPluginComponent.emits]);

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent();

const { purchaseBill } = storeToRefs(usePurchaseBillStore());
const { cancelPurchaseBill, getPurchaseBills } = usePurchaseBillStore();
const { togglePurchaseBillForm } = usePurchaseBillStore();

const { counts } = storeToRefs(usePurchaseOrderStore());

const { purchaseOrder } = storeToRefs(usePurchaseOrderStore());

const formData = ref(extend(true, {}, unref(purchaseBill)));
const isLoading = ref(false);
const removeFiles = ref(true);

const confirmationHandler = async (dialog) => {
  try {
    dialog?.hide();

    isLoading.value = true;

    await cancelPurchaseBill({
      purchaseBill: unref(formData),
      removeFiles: unref(removeFiles),
    });

    isLoading.value = false;

    await getPurchaseBills({
      filters: {
        page_size:
          unref(counts)["bills_count"] < 25 ? 25 : unref(counts)["bills_count"],
        po_id: unref(purchaseOrder)._id,
      },
    });

    onDialogOK();

    togglePurchaseBillForm({ open: false });
  } catch {
    isLoading.value = false;
  }
};

const onSubmit = () => {
  const dialog = $q.dialog({
    component: PConfirmDialog,
    componentProps: {
      text: "Are you sure you want to cancel the Purchase Bill ?",
      labelClass: "text-center q-ma-xl rounded-borders",
      onConfirm: () => confirmationHandler(dialog),
    },
  });
};
</script>
